export default __webpack_public_path__ + "static/media/booongo_logo.a3b27acd.png";